var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFgwLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 37,
    viewBox: "0 0 49 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 49,
    height: 37,
    fill: "#E3ECF0"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Pending Error Review"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-1706 -3600C-1706 -3601.1 -1705.1 -3602 -1704 -3602H16457C16458.1 -3602 16459 -3601.1 16459 -3600V950C16459 951.104 16458.1 952 16457 952H-1704C-1705.1 952 -1706 951.104 -1706 950V-3600Z",
    fill: "white",
    fillOpacity: 0.24
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-1704 -3601H16457V-3603H-1704V-3601ZM16458 -3600V950H16460V-3600H16458ZM16457 951H-1704V953H16457V951ZM-1705 950V-3600H-1707V950H-1705ZM-1704 951C-1704.55 951 -1705 950.552 -1705 950H-1707C-1707 951.657 -1705.66 953 -1704 953V951ZM16458 950C16458 950.552 16457.6 951 16457 951V953C16458.7 953 16460 951.657 16460 950H16458ZM16457 -3601C16457.6 -3601 16458 -3600.55 16458 -3600H16460C16460 -3601.66 16458.7 -3603 16457 -3603V-3601ZM-1704 -3603C-1705.66 -3603 -1707 -3601.66 -1707 -3600H-1705C-1705 -3600.55 -1704.55 -3601 -1704 -3601V-3603Z",
    fill: "black",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Pending Error Review_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "FooterNEW"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-3-inside-1_10_13",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-579 -32H1341V273.938H-579V-32Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-579 -32H1341V273.938H-579V-32Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-579 -31H1341V-33H-579V-31Z",
    fill: "#E0E0E0",
    mask: "url(#path-3-inside-1_10_13)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Frame 5340"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g3344"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g3346"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g3358"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3360",
    d: "M4.32484 27.5056V26.4837H0.5V36.3638H1.4368V31.463H4.23563V30.441H1.4368V27.5056H4.32484ZM10.1463 31.3978V32.4196H12.6441C12.6441 34.2539 11.1057 35.5119 9.64465 35.5119C8.76344 35.5119 7.87156 34.9737 7.25797 34.2539C6.63352 33.5068 6.27679 32.5104 6.27679 31.463C6.27679 29.2351 7.79347 27.3355 9.71145 27.3355C10.9497 27.3355 11.8971 28.0297 12.5995 29.1961L13.28 28.4492C12.3881 27.0863 11.1948 26.313 9.72221 26.313C7.30253 26.313 5.3399 28.6201 5.3399 31.4497C5.3399 34.2275 7.30253 36.5338 9.66644 36.5338C10.8375 36.5338 12.0086 35.9312 12.7783 34.8829C13.548 33.8345 13.6702 32.7342 13.6485 31.3978H10.1463ZM15.2872 26.4837H14.2723L17.4952 36.874L20.2164 28.9213L22.9377 36.874L26.1613 26.4837H25.146L22.9377 33.8874L20.2164 25.9727L17.4952 33.8874L15.2872 26.4837Z",
    fill: "#005B7E"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3362"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3364",
    d: "M23.2916 17.4134C20.8945 16.5871 18.482 16.1685 16.1213 16.1685C15.2165 16.1685 14.3209 16.233 13.4356 16.3542L11.8594 18.7109C14.4557 18.2644 17.1417 18.432 19.7938 19.3038C27.0399 21.6835 31.8683 28.203 33.9488 36.2686H40.5456C36.7015 26.8864 29.8603 19.6777 23.2916 17.4134Z",
    fill: "#005B7E"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3366"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3368",
    d: "M38.9373 22.9145C35.5028 19.142 32.519 16.2885 25.3679 13.9186C22.9747 13.1253 20.5627 12.7233 18.2001 12.7233C17.3755 12.7233 16.559 12.7761 15.7503 12.8728L14.2031 15.1849C14.8371 15.1254 15.4753 15.0923 16.1184 15.0923C18.5577 15.0923 21.048 15.524 23.5203 16.3777C28.8012 18.1969 34.1074 22.9541 38.0796 29.429C39.4119 31.6016 40.55 33.8907 41.4837 36.249H48.4992C48.1542 35.6597 47.8046 35.0819 47.4535 34.5106L43.5377 28.6548C41.8439 26.3195 40.2406 24.3466 38.9373 22.9145Z",
    fill: "#568498"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3370"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3372",
    d: "M25.5927 12.9062C32.048 15.0457 35.2914 17.6774 38.3072 20.8389L24.3726 -0.000127792L16.5117 11.7447C17.0711 11.701 17.6338 11.6745 18.2009 11.6745C20.6389 11.6745 23.1261 12.0889 25.5927 12.9062Z",
    fill: "#96B4C3"
  }))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFgwLogo);
export default __webpack_public_path__ + "static/media/fgwLogo.8acf10b117dd3ceaf3dc2c7462434fed.svg";
export { ForwardRef as ReactComponent };